module.exports = __webpack_public_path__ + "media/images/mobile/abouts/4-d2c4f58d4c5fa3abd65d19d6a7456665.jpg";